import { NavLink, ThemeIcon } from '@mantine/core';
import { IconSettings2 } from '@tabler/icons';
import { AppRoutePaths } from '../../../utils/enums/routes';

interface SystemLinkProps {
  navigate(route: string): void;
}

export function SystemLink({ navigate }: SystemLinkProps) {
  return (
    <NavLink
      styles={{
        label: {
          color: '#373A40',
        },
      }}
      label="Sistema"
      fw="bold"
      color=""
      icon={
        <ThemeIcon color="pink" variant="light">
          <IconSettings2 size={16} />
        </ThemeIcon>
      }
      childrenOffset={28}
    >
      <NavLink
        label="Novo Acesso"
        onClick={() => navigate(AppRoutePaths.ACCESS_CREATE)}
      />
    </NavLink>
  );
}
